module.exports = {

  'app.groupUser.crud.validate.1': 'Vui lòng nhập đúng định dạng từ 3 đến 50 ký tự',

  
  
    

  };